import { IconProps } from "../../types/utils";

const AccountIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 13}
    height={dimension || 16}
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 15.1666C13 15.5656 12.6766 15.8888 12.2778 15.8888C11.8788 15.8888 11.5554 15.5656 11.5554 15.1666C11.5554 12.3744 9.29216 10.1112 6.5 10.1112C3.70784 10.1112 1.44457 12.3745 1.44457 15.1666C1.44457 15.5656 1.12115 15.8888 0.722157 15.8888C0.323413 15.8888 0 15.5656 0 15.1666C0 11.5767 2.9101 8.66665 6.5 8.66665C10.0899 8.66665 13 11.5767 13 15.1666ZM6.5 7.94443C4.30625 7.94443 2.52765 6.16609 2.52765 3.97208C2.52765 1.77834 4.30625 0 6.5 0C8.69375 0 10.4724 1.77834 10.4724 3.97208C10.4724 6.16602 8.69375 7.94443 6.5 7.94443ZM6.5 6.50012C7.89595 6.50012 9.02771 5.36836 9.02771 3.97215C9.02771 2.5762 7.89595 1.44444 6.5 1.44444C5.10405 1.44444 3.97229 2.5762 3.97229 3.97215C3.97229 5.36836 5.10405 6.50012 6.5 6.50012Z"
      fill={color || "white"}
    />
  </svg>
);

export default AccountIcon;
